import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

interface LobbyCardProps {
  icon?: React.ReactNode;
  title: string;
  description: string;
  cta?: string;
  to: string;
  onClick?: () => void;
}

export const LobbyCard = (props: LobbyCardProps) => {
  const { icon, title, description, cta } = props;

  return (
    <Box
      sx={{
        '.lobby-card': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          background: 'white',
          maxWidth: '220px',
          minWidth: '220px',
          minHeight: '260px',
          pt: '38px',
          px: '17px',
          pb: '15px',
          textDecoration: 'none',
          textAlign: 'center',
          '& svg': {
            width: '60px',
            height: '60px',
            color: '#424242',
          },
          boxShadow: '3px 3px 12px 0px rgba(0, 0, 0, 0.03)',
          '.lobby-card-cta': {
            color: 'info.main',
          },
          '*': {
            textAlign: 'center',
          },
        },
      }}
    >
      <NavLink onClick={props.onClick} className="lobby-card" to={props.to}>
        {icon && icon}
        <Typography
          sx={{ fontSize: '16px', fontWeight: 600, mt: icon ? '1rem' : 0 }}
        >
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
        {cta && (
          <Typography
            className="lobby-card-cta"
            variant="body2"
            sx={{ mt: 'auto', mb: '1rem' }}
          >
            {cta}
          </Typography>
        )}
      </NavLink>
    </Box>
  );
};
